export const ALLOWED_TO_ADDITIONAL_DISCHARGES_SUBJECT = 'additionalDischargeAlgorithm';
